import CoreLibrary from "../../../helpers/CoreLibrary";

export const ActionMixin = {
	extends: CoreLibrary,
	inject: ["eventHub"],
	props: {
		actions: {
			required: true,
			type: Array,
		},
		absenChecked: {
			type: Boolean,
		},
		uniqueKey: {},
		rowData: {},
		leadProfilePlacementSubTabLists: {
			type: Array,
			default: function () {
				return [];
			},
		},
		studentProfilePlacementSubTabLists: {
			type: Array,
			default: function () {
				return [];
			},
		},
		scheduleRecommendationTableHideFunc: {
			type: Function,
		},
		scheduleRecommendationTableHideVal: {
			type: Boolean,
		},
		columnType: {
			type: String,
		},
		columnTitle: {
			type: String,
		},
	},
	data() {
		return {
			action: {},
			viewClcCalendarDetailVal: true,
			isAbsenChecked: this.absenChecked,
		};
	},
	methods: {
		modal() {
			$(`#${this.action.modalId}`).modal("show");
		},
		// pageRedirect(action) {
		//     // default
		//     // window.location = `${this.action.url}/${this.actionUniqueKey(action)}`;

		// 	if (this.action.target === "_blank")
		//         window.open(`${this.action.url}/${this.action.uniqueKey ?? ''}`)
		//     else if (this.action.target === "")
		//         window.location = `${this.action.url}/${this.action.uniqueKey ?? ''}`;
		// },
		pageRedirect(action) {
			const uniqueKeyValue = this.actionUniqueKey(action); // Pass the action as an argument
			if (this.action.target === "_blank")
				window.open(`${action.url}/${uniqueKeyValue}`);
			else if (this.action.target === "")
				window.location = `${action.url}/${uniqueKeyValue}`;
		},
		decidePageRedirectPlacement(rowData, action) {
			let url = "";
			let uniqueKeyValue = this.actionUniqueKey(action);
			if (rowData?.sub_status?.id !== 13) {
				url = "/transaction/profile-lead/" + uniqueKeyValue;
			} else if (rowData?.sub_status?.id === 13) {
				url = "/transaction/profile-student/" + uniqueKeyValue;
			}

			if (action.target === "_blank") window.open(url);
			if (action.target === "") window.location = url;
		},
		// actionUniqueKey(){
		//     return this.action.uniqueKey ? this.rowData[this.action.uniqueKey] : this.uniqueKey;
		// },
		actionUniqueKey(action) {
			if (action && typeof action.uniqueKey === "function") {
				return action.uniqueKey(this.rowData);
			}
			return action && action.uniqueKey
				? this.rowData[action.uniqueKey]
				: this.uniqueKey;
		},
		customSubTab(action) {
			let callbackId = action.callbackId(this.rowData);
			const isExist = this.leadProfilePlacementSubTabLists.find(
				(item) => item.id === callbackId
			);
			if (isExist && isExist.function) {
				isExist.function(this.rowData);
			}
		},
		customSubTabStudent(action) {
			let callbackId = action.callbackId(this.rowData);
			const isExist = this.studentProfilePlacementSubTabLists.find(
				(item) => item.id === callbackId
			);
			if (isExist && isExist.function) {
				isExist.function(this.rowData);
			}
		},
		// callMethod(e, action) {
		//     this.action = action;
		//     if (action.type === "modal") this.modal()
		//     else if (action.type === "page") this.pageRedirect();
		//     this.sendAction();
		// },
		callMethod(e, action) {
			this.action = action;
			if (action.type === "modal") {
				this.modal();
			} else if (action.type === "page")
				this.pageRedirect(action); // Pass the action
			else if (action.type === "decide-placement-page") {
				this.decidePageRedirectPlacement(this.rowData, action);
			} else if (action.type === "custom-sub-tab" && action.callbackId) {
				this.customSubTab(action);
			} else if (action.type === "custom-sub-tab-student" && action.callbackId) {
				this.customSubTabStudent(action);
			}
			if (action.type === "viewAndHideAssignSchedule") {
				this.scheduleRecommendationTableHideFunc(
					!this.scheduleRecommendationTableHideVal,
					this.rowData
				);
				return;
			}
			if (action.type === "viewAndHideTeacherPagesStudentSchedule") {
				this.eventHub.$emit(
					"viewAndHideTeacherPagesStudentSchedule",
					this.rowData
				)
				return;
			}
			if (action.type === "viewAndHideTeacherPagesStudentAttendance") {
				this.eventHub.$emit(
					"viewAndHideTeacherPagesStudentAttendance",
					this.rowData
				)
				return;
			}
			if (action.type === "viewClcCalendarDetail") {
				this.eventHub.$emit(
					"viewClcCalendarDetailEvent",
					this.viewClcCalendarDetailVal,
					this.rowData
				);
				this.viewClcCalendarDetailVal = !this.viewClcCalendarDetailVal;
				return;
			}
			if (action.type === "duplicate-invoice") {
				this.sendAction();
				return;
			}
			if (action.type === "detail-usages-deductions") {
				this.sendAction();
				return;
			}
			this.sendAction();
		},
		sendAction() {
			this.$emit("action", this.rowData, this.action, true);
		},
		handleAbsenCheckboxChange() {
			this.$emit("getChecked", this.rowData, this.isAbsenChecked);
		}
	},
	computed: {
		visibleActions() {
			return this.actions.filter((action) => {
				if (this.isUndefined(action.title)) return false;
				if (this.isUndefined(action.modifier)) return true;
				return action.modifier(this.rowData);
			});
		},
	},
};
